(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  let cleanupHanfiMobileFacetBar = () => {};

  const setupHanfiMobileFacetBar = () => {
    cleanupHanfiMobileFacetBar();

    const media = window.matchMedia('(max-width: 749px)');
    const wrapper = document.querySelector('.product-grid-container .collection-wrapper');
    const bar = wrapper?.querySelector('.facets-toggle');

    if (!wrapper || !bar) return;

    let anchorTop = 0;

    const getScrollTop = () =>
      Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, document.body.scrollTop || 0);

    const readOffset = () => {
      const value = getComputedStyle(bar).getPropertyValue('--hanfi-filter-sticky-offset-mobile');
      const parsed = Number.parseFloat(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const release = () => {
      bar.classList.remove('hanfi-facets-toggle--fixed');
      wrapper.classList.remove('hanfi-mobile-facets-is-fixed');
    };

    const measure = () => {
      release();
      anchorTop = bar.getBoundingClientRect().top + getScrollTop();
    };

    const update = () => {
      if (!media.matches) {
        release();
        return;
      }

      const shouldFix = getScrollTop() >= anchorTop - readOffset();
      bar.classList.toggle('hanfi-facets-toggle--fixed', shouldFix);
    };

    measure();
    update();

    const handleResize = () => {
      measure();
      update();
    };
    const handleMediaChange = () => {
      measure();
      update();
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', handleResize);
    media.addEventListener?.('change', handleMediaChange);

    cleanupHanfiMobileFacetBar = () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', handleResize);
      media.removeEventListener?.('change', handleMediaChange);
      release();
      cleanupHanfiMobileFacetBar = () => {};
    };
  };

  document.addEventListener('DOMContentLoaded', setupHanfiMobileFacetBar, { once: true });
  document.addEventListener('shopify:collection:update', (event) => {
    event.promise?.finally(() => requestAnimationFrame(setupHanfiMobileFacetBar));
  });
  document.addEventListener('shopify:search:update', (event) => {
    event.promise?.finally(() => requestAnimationFrame(setupHanfiMobileFacetBar));
  });

  } catch(e) { console.error(e); }
})();
})();
